import React from 'react';
import './SessionTimeoutModal.css';

const SessionTimeoutModal = ({ showWarning, warningCountdown, onContinue }) => {
  if (!showWarning) return null;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-modal">
        {/* Header with icon */}
        <div className="timeout-header">
          <div className="timeout-icon">
            <i className="fas fa-clock"></i>
          </div>
          <h2>Session Timeout Warning</h2>
        </div>

        {/* Message */}
        <div className="timeout-message">
          <p>
            You have been inactive for <strong>15 minutes</strong>. 
            For security reasons, you will be automatically logged out in:
          </p>
        </div>

        {/* Countdown Timer */}
        <div className="timeout-countdown">
          <div className="countdown-number">
            {warningCountdown}
          </div>
          <div className="countdown-label">seconds</div>
        </div>

        {/* Warning text */}
        <div className="timeout-warning">
          <p>
            <i className="fas fa-exclamation-circle"></i>
            Click "Continue Session" to stay logged in
          </p>
        </div>

        {/* Action Button */}
        <button 
          className="continue-session-btn"
          onClick={onContinue}
        >
          <i className="fas fa-check-circle"></i>
          Continue Session
        </button>

        {/* Additional info */}
        <div className="timeout-info">
          <small>Keep working to automatically extend your session</small>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
